import { Box, Card, Typography, useTheme, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { StationData } from "types/auth";
import LocationIcon from "assets/icons/location";
import StationSelectDialog from "./dialog/station-select-dialog";

const StationDetailCard = ({ stationDetail }: { stationDetail: StationData }) => {
	const theme = useTheme();
	const navigate = useNavigate();

	return (
		<Card
			sx={{
				bgcolor: "#E1F2FF",
				color: theme.palette.primary.contrastText,
				border: "1px solid #269FFF",
				mb: 1.5,
				minHeight: 80,
				display: "flex",
				alignItems: "center",
			}}
		>
			{stationDetail ? (
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						p: 2,
						gap: 1,
						width: 1
					}}
				>
					<Stack spacing={0.5} sx={{ flex: 1 }}>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								width: 1
							}}
						>
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									gap: 0.5
								}}
							>
								<LocationIcon  color={"#269FFF"} />
								<Typography
									component="span"
									sx={{
										fontSize: 18,
										fontWeight: 700,
										lineHeight: 1.2,
										color: "#269FFF"
									}}
								>
									{stationDetail.stationName}
								</Typography>
							</Box>

							<StationSelectDialog />
						</Box>

						<Typography
							variant="body2"
							sx={{
								fontSize: 14,
								fontWeight: 400,
								lineHeight: 1.5,
								color: "#2B2B2B"
							}}
						>
							旗站地址：{stationDetail.location}
						</Typography>

						<Typography
							variant="body2"
							sx={{
								fontSize: 14,
								fontWeight: 400,
								lineHeight: 1.5,
								color: "#2B2B2B"
							}}
						>
							活動名稱：{stationDetail.eventName}
						</Typography>

						<Typography
							variant="body2"
							sx={{
								fontSize: 14,
								fontWeight: 400,
								lineHeight: 1.5,
								color: "#2B2B2B"
							}}
						>
							活動開始時間：{stationDetail.eventDate}
						</Typography>
					</Stack>
				</Box>
			) : (
				<Box
					width={1}
					sx={{
						p: 2,
						cursor: "pointer",
						transition: "opacity 0.2s",
						"&:hover": {
							opacity: 0.9,
						}
					}}
					onClick={() => navigate("/setting", { replace: true })}
				>
					請選擇旗站
				</Box>
			)}
		</Card>
	);
};

export default StationDetailCard;
